export default __webpack_public_path__ + "static/media/firmware-update.9c89af57.svg";